// extracted by mini-css-extract-plugin
module.exports = {"s1gvsyfu":"s1gvsyfu"};